import axios from "axios";
import { API_URL } from "../../constants";

export const GetSingleEvent = async (eventId,ApiStatus) => {
    ApiStatus({ isLoader: true, isError: false, data: null });
    const token = localStorage.getItem('LOGIN_TOKEN');

    try {
        let res = await axios.get(API_URL + "event/detail/"+eventId, {
            headers: {
                'Authorization': "Bearer " + token,
            }
        });
        ApiStatus({ isLoader: false, isError: false, data: res.data });
    } catch (err) {
        ApiStatus({ isLoader: false, isError: true, data: null });
    }

}